<template>
  <ArticleAuthorSection
    :author="author"
    :author-id="authorId"
    class="tw-border-y tw-bg-white tw-px-0"
  />
</template>

<script setup lang="ts">
defineProps<{
  author: ArticleAuthor
  authorId?: string | null
}>()
</script>
